module.exports = __webpack_public_path__ + "img/camera.4e090558.svg";